export const bartOAKAirport = [
    [37.713250281622436, -122.21222589441264],
    [37.71506336784569, -122.21056944198799],
    [37.71596478248272, -122.20917453482684],
    [37.7162813767861, -122.20837631682251],
    [37.71706362432821, -122.20600716579361],
    [37.717467803366894, -122.20483670741052],
    [37.7180742692638, -122.20349055272126],
    [37.71868796820552, -122.20262248376305],
    [37.719801759548936, -122.20157074685379],
    [37.72128212017695, -122.20068002080795],
    [37.722548951082054, -122.20039254262045],
    [37.72379053030004, -122.20035380437685],
    [37.724300108540746, -122.20026522326683],
    [37.725287494047436, -122.19956106569235],
    [37.72580226936956, -122.1995150385542],
    [37.72734029229201, -122.19991755155026],
    [37.729453670063265, -122.20002239170557],
    [37.73015664121043, -122.19993584687597],
    [37.73624063335955, -122.19697323209923],
    [37.737997356899925, -122.196707211317],
    [37.738486232054996, -122.19671522462603],
    [37.73900024384261, -122.19698690554621],
    [37.73951442241656, -122.19708148804702],
    [37.74188243908397, -122.1968972470156],
    [37.742296875180145, -122.19684374499714],
    [37.74437832360865, -122.19611231056533],
    [37.74674144717799, -122.19604162114739],
    [37.748788246670046, -122.19628615160416],
    [37.74951169946223, -122.19664853007451],
    [37.75090422972959, -122.19695806101923],
    [37.75143739962006, -122.19696320046036],
    [37.752451715443385, -122.19607325564698],
];